import React, { useState, useRef } from "react";
import { FaChevronDown, FaTimes, FaBars } from "react-icons/fa";
import logo from "../assets/techsaazlogo.jpeg";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 300);
  };

  return (
    <div>
      <div className="bg-white text-gray-700 p-4 shadow-md fixed top-0 left-0 w-full z-50">
        <div className="max-w-7xl mx-auto flex items-center">
          <a href="/" className="mr-8">
            <h2 className="text-blue-600 text-2xl font-[800]">BizzDevs</h2>
          </a>

          <div className="hidden sm:flex items-center space-x-6 font-bold relative">
            <a href="/home" className="relative hover:text-blue-700 group">
              Home
              <span className="absolute bottom-[-6px] left-0 w-full h-[3px] bg-blue-700 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
            </a>

            <div
              className="relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <a href="service-page" className="flex items-center relative group">
                <span className="group-hover:text-blue-700">Services</span>
                <FaChevronDown className="ml-1 transition-transform duration-300 group-hover:text-blue-700" />
                <span className="absolute bottom-[-6px] left-0 w-full h-[3px] bg-blue-700 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
              </a>

              {isDropdownOpen && (
                <div className="absolute left-0 top-full w-56 bg-white text-black rounded-lg shadow-lg z-10 font-normal mt-2 p-2">

                  <a href="/artificial" className="block px-4 py-2 hover:text-blue-600">Artificial Intelligence</a>
                  <a href="business-devlopment" className="block px-4 py-2 hover:text-blue-600">Business Development</a>
                  <a href="/web-development" className="block px-4 py-2 hover:text-blue-600">Web Development</a>
                  <a href="/mobile-app" className="block px-4 py-2 hover:text-blue-600">Mobile App</a>
                  <a href="/graphic-designing" className="block px-4 py-2 hover:text-blue-600">Graphic Designing</a>
                  <a href="/dev-ops" className="block px-4 py-2 hover:text-blue-600">DevOps</a>
                  <a href="SQInsurance" className="block px-4 py-2 hover:text-blue-600">Software Testing</a>
                </div>
              )}
            </div>

            <a href="/portfolio" className="relative hover:text-blue-700 group">
              Projects
              <span className="absolute bottom-[-6px] left-0 w-full h-[3px] bg-blue-700 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
            </a>

            <a href="/customers" className="relative hover:text-blue-700 group">
              Customers
              <span className="absolute bottom-[-6px] left-0 w-full h-[3px] bg-blue-700 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
            </a>
            <a href="/About" className="relative hover:text-blue-700 group">
              About
              <span className="absolute bottom-[-6px] left-0 w-full h-[3px] bg-blue-700 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
            </a>
            <a href="/career" className="relative hover:text-blue-700 group">
              Careers
              <span className="absolute bottom-[-6px] left-0 w-full h-[3px] bg-blue-700 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
            </a>

            <a href="/contact-us">
              <button className="px-6 py-2 text-lg font-semibold rounded-lg bg-blue-600 text-white">
                Contact
              </button>
            </a>
          </div>

          <div className="sm:hidden flex items-center ml-auto">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700">
              {isMenuOpen ? <FaTimes className="w-6 h-6" /> : <FaBars className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-lg z-50 p-6 flex flex-col space-y-4">
          <button className="self-end mb-4" onClick={() => setIsMenuOpen(false)}>
            <FaTimes className="w-6 h-6 text-gray-700" />
          </button>

          <a href="/home" className="py-2 text-gray-700 font-bold border-b">Home</a>

          <div className="py-2 border-b">
            <button
              className="flex justify-between w-full text-gray-700 font-bold py-2"
              onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
            >
              Services <FaChevronDown className={`ml-1 transition-transform ${isMobileDropdownOpen ? "rotate-180" : ""}`} />
            </button>
            {isMobileDropdownOpen && (
              <div className="pl-4 mt-2 space-y-3">
                <a href="business-devlopment" className="block text-gray-900">Business Development</a>
                <a href="/artificial" className="block text-gray-900">Artificial Intelligence</a>
                <a href="/web-development" className="block text-gray-900">Web Development</a>
                <a href="/mobile-app" className="block text-gray-900">Mobile App</a>
                <a href="/graphic-designing" className="block text-gray-900">Graphic Designing</a>
                <a href="/dev-ops" className="block text-gray-900">DevOps</a>
                <a href="SQInsurance" className="block text-gray-900">Software Testing</a>
              </div>
            )}
          </div>

          <a href="/portfolio" className="py-2 text-gray-700 font-bold border-b">Projects</a>
          <a href="/customers" className="py-2 text-gray-700 font-bold border-b">Customers</a>
          <a href="/about" className="py-2 text-gray-700 font-bold border-b">About</a>
          <a href="/career" className="py-2 text-gray-700 font-bold border-b">Careers</a>

          <a href="/contact-us" className="mt-6">
            <button className="w-full px-6 py-2 text-lg font-semibold rounded-lg bg-blue-600 text-white">
              Contact
            </button>
          </a>
        </div>
      )}
    </div>
  );
};

export default Navbar;
